export function Slash({ name }: { name: string }) {
  return <span className="slash-cmd">/{name}</span>;
}
